const scenariosData = [
	{
		id: 'scenario-1',
		playerLoginType: 'employee-id',
		title: {
			da: 'Grundlæggende grilltræning',
			en: '',
		},
		languageIds: ['da', 'en'],
		modulesData: require('data/scenarios/scenario-1/modules-data').modulesData,
		moduleGroups: require('data/scenarios/scenario-1/modules-data').moduleGroups,
	},
];

export {
	scenariosData
};